import { Box } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import { useMemo } from "react";

import Text from "../../text/Text";
import { Tag } from "../../tag/Tag";
import {
  deposit,
  failedToLoadData,
  limited,
  limitErrorTxt,
  receive,
  retry,
  unlimited,
  upgradeKycText,
  upgradeNow,
} from "../../messages";
import { CustomLink } from "../../link/Link";
import CommonSkeleton from "../../CommonSkeleton";
import LimitCard from "./LimitCard";
import { errorIcons } from "../../images";

const LimitList = ({
  data,
  type,
  userPlan,
  error,
  isLoading,
  getData,
  setOpenModal,
}) => {
  const isLimited = type !== receive;

  const showUpgradeText = useMemo(() => {
    const isDeposit = type === deposit;
    return isDeposit && !userPlan;
  }, [type, userPlan]);

  const upgradeTxt = (
    <Box mt="14px">
      <Text size={16} className="grey-text">
        {upgradeKycText}
      </Text>
      <Text
        size={16}
        sx={{ cursor: "pointer", width: "fit-content" }}
        font="semibold"
        className="blue-text"
        onClick={() => setOpenModal(true)}
      >
        {upgradeNow}
      </Text>
    </Box>
  );

  const errorUI = useMemo(
    () => (
      <Box className="limit-error-container">
        {errorIcons.invalid}
        <Text size={20} font="bold">
          {failedToLoadData}
        </Text>
        <Text size={16} className="grey-text">
          {limitErrorTxt}
        </Text>
        <CustomLink
          bold
          sx={{ margin: "auto" }}
          alignIcon="start"
          withIcon={<ReplayIcon />}
          onClick={() => getData()}
        >
          {retry}
        </CustomLink>
      </Box>
    ),
    []
  );
  const loadingUI = useMemo(
    () => (
      <Box className="limit-card" gap={4}>
        <CommonSkeleton variant="circular" height={"20px"} width="20%" />
        <Box display="flex" alignItems="center" gap={1}>
          <CommonSkeleton variant="rectangular" width="20%" height="20px" />
          <CommonSkeleton variant="rectangular" width="80%" height="20px" />
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <CommonSkeleton variant="rectangular" width="20%" height="20px" />
          <CommonSkeleton variant="rectangular" width="80%" height="20px" />
        </Box>
      </Box>
    ),
    []
  );

  const limitCards = useMemo(() => {
    if (isLoading) {
      return loadingUI;
    } else if (error) {
      return errorUI;
    } else {
      return data?.map((limit, index) => (
        <LimitCard key={index} type={type} data={limit} />
      ));
    }
  }, [type, data, isLoading, error]);

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Text size={16} font="bold">
          {type}
        </Text>
        <Tag
          text={isLimited ? limited : unlimited}
          variant={isLimited ? "warning" : "primary"}
        />
      </Box>
      <Box margin="20px 0">{showUpgradeText ? upgradeTxt : limitCards}</Box>
    </Box>
  );
};

export default LimitList;
